<app-material class="left">
    <app-atom-requests body></app-atom-requests>
</app-material>

<app-material class="right">
    <app-line-requests body></app-line-requests>
</app-material>
